// extracted by mini-css-extract-plugin
export default {"container":"ButtonPlus_container__pPaf-","small":"ButtonPlus_small__WMCeJ","tiny":"ButtonPlus_tiny__AU6nu"};